//App.js
import React from "react";
import {
	BrowserRouter as Router,
	Route,
	Link,
	Routes,
	Outlet,
} from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";

//import Events from './Events';
//import VenThero from './VenThero';

import './css/Navbar.css';
import 'bootstrap/dist/css/bootstrap.min.css';


function TempleNavbar() {
	return (
		<Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
			<Container>
				<Navbar.Brand href="/home" >
					<img className="img-fluid float-left img-responsive" src="logo.png" alt="TempleLogo" />
				</Navbar.Brand>
				<span className="brand-text">Dhammadeepa Meditation Centre</span>

				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="ml-auto fs-6">
						<Nav.Link as={Link} to="/home" className="btn ml-1 menuText">Home</Nav.Link>
						<Nav.Link as={Link} to="/venThero" className="btn ml-1 menuText">Chief Incumbent Thero</Nav.Link>
						<Nav.Link as={Link} to="/purpose" className="btn ml-1 menuText">Our Purpose</Nav.Link>
						<Nav.Link as={Link} to="/temples" className="btn ml-1 menuText">Meditation Centres</Nav.Link>
						<Nav.Link as={Link} to="/events" className="btn ml-1 menuText">Events</Nav.Link>
						<Nav.Link as={Link} to="/sundaySchool" className="btn ml-1 menuText">Sunday School</Nav.Link>
						<Nav.Link as={Link} to="/donate" className="btn ml-1 menuText">Donate</Nav.Link>
						<Nav.Link as={Link} to="/contactUs" className="btn ml-1 menuText">Contact Us</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}
export default TempleNavbar;
